import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase } from './serviceBase';

@Injectable({
  providedIn: 'root'
})
export class NewsService extends ServiceBase {

  getNews(): Observable<string> {
    return this.httpClient.get('/assets/home/news/news.html', { responseType: "text" });
  }
}
